import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import AccountStateTable from "./Table/accountStatementTable";

const AccountStatementPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="accountstatement_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="All Credit Debit"
      countContainer="My Wallet Balance : 0.00 TRX"
      table={<AccountStateTable />}
      calculateContainer={true}
      calculateCredit="Total Credit : 0.00"
      calculateDebit="Total Debit : 0.00"
    />
  );
};

export default AccountStatementPage;
